import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import {
  FormLabel,
  TextField,
  Button,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
  Divider
} from "@material-ui/core";

function ViewBatch() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [search, setSearch] = useState("");
  const [course, setCourse] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  const [rowCount, setRowCount] = useState("");

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editbatch") {
      navigate(`/admin/editbatch/${rowId}`);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const allCourseIds = course?.map((c) => c.id) || [];

  const isAllSelected =
    selectedCourse?.length === allCourseIds.length && allCourseIds.length > 0;

  const isIndeterminate =
    selectedCourse?.length > 0 && selectedCourse?.length < allCourseIds.length;

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedCourse([]); // Deselect all
    } else {
      setSelectedCourse(allCourseIds); // Select all
    }
  };

  const handleCourseChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelectedCourse(typeof value === "string" ? value.split(",") : value);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async (pageNumber, size) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch?page=${
          pageNumber + 1
        }&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setBatches(response.data.batches);
      setRowCount(response.data.count);
      //  console.log("response?.data", response?.data?.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchCourse = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setCourse(response.data.courses);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchCourse();
  }, []);

  useEffect(() => {
    if (
      onPage !== undefined &&
      pageSize !== undefined &&
      searchQuery !== undefined
    ) {
      fetchData(onPage, pageSize, searchQuery);
    }
  }, [onPage, pageSize, searchQuery]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      console.log("Batch deleted:", response.data);
      fetchData(onPage, pageSize, searchQuery);
      handleClose();
      toast.success("Batch deleted successfully");
      const updateddatatata = batches.filter((data) => data.id !== rowId);
      setBatches(updateddatatata);
    } catch (error) {
      toast.error("Batch is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      batch: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/status`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      })
      .then((response) => {
        fetchData(onPage, pageSize, searchQuery);
        toast.success("Batch status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Batch status:", error);
        toast.error("Batch status is not changed");
      });
  };

  const rows = batches.map((d) => ({
    id: d.id ? d.id : "N/A",
    course_name: d.course.course_name ? d.course.course_name : "N/A",
    batch_name: d.batch_name ? d.batch_name : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));
  const startIndex = onPage * pageSize;
  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch =
        d.batch_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        d.course_name.toLowerCase().includes(searchQuery.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "batch_name",
      headerName: "Batch Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "course_name",
      headerName: "Course Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.w100} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editbatch", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      // inputlable: "Batch / Course",
      inputplaceholder: "Search Batch Name",
       export: "yes",
      import: "yes",
      exportFileName: "Batch.csv",
      importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/import/csv`,
      exportApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/export/all`,
      fetchData: () => fetchData(onPage, pageSize),
    },
  ];

  const style = [
    {
      height: "maxh67",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.pagescroll} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} onSearch={handleSearch} />

        <div className={`${classes.dflex} ${classes.m0_5}`}>
          {/* <div
            className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
                          ${classes.lineheight}`}
            >
              Select Course
            </FormLabel>
            <Select
              labelId="exam-label"
              id="exam"
              multiple
              value={selectedCourse}
              onChange={handleCourseChange}
              displayEmpty
              MenuProps={menuProps}
              variant="outlined"
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return (
                    <em className={classes.defaultselect}>Select course</em>
                  );
                }

                return course
                  ?.filter((e) => selected.includes(e.id))
                  .map((e) => e.course_name)
                  .join(", ");
              }}
            >
              <MenuItem
                onClick={handleSelectAll}
                dense
                disableGutters
                sx={{ py: 0 }}
              >
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={isIndeterminate}
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                />
                <ListItemText
                  primary={isAllSelected ? "Deselect All" : "Select All"}
                />
              </MenuItem>

              <Divider />

              {course?.map((data) => (
                <MenuItem
                  key={data.id}
                  value={data.id}
                  dense
                  disableGutters
                  sx={{ py: 0 }}
                >
                  <Checkbox
                    size="small"
                    checked={selectedCourse?.includes(data.id)}
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                  />
                  <ListItemText primary={data.course_name} sx={{ p: 0 }} />
                </MenuItem>
              ))}
            </Select>
          </div> */}
          {/* <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
            >
              Search
            </FormLabel>
            <TextField
              type="text"
              variant="outlined"
              required
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Batch Name"
            />
          </div> */}
{/* 
          <div className={`${classes.dflex} ${classes.flexdirectioncolumn}`}>
            <Button
              className={`${classes.custombtnblue} ${classes.mt1_5} ${classes.ml0_5}`}
              onClick={() => fetchData(onPage, pageSize)}
            >
              search
            </Button>
          </div> */}
          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          ></div>
        </div>
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
    </>
  );
}
export default ViewBatch;
